import { 
	createSlice,
    createAsyncThunk,
    createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'


export const startProgramBuild = createAsyncThunk(
	'startProgramBuild',
	async (payload,thunkAapi) => {
		//clear out existing events to prevent flicker
		thunkAapi.dispatch(clearProgramEventsData())
		return envAwarePost('programsMobWeb/',{
	        operation: "add",
	        programLength: payload.programLength,
	        programName: payload.programName,
	        programNotes: payload.programNotes,
		})
	}
)

export const editProgramBuildLength = createAsyncThunk(
	'editProgramBuild',
	async (payload) => envAwarePost('programsMobWeb/',{
        operation: "edit",
        programLength: payload.newlength,
        programName: payload.programName,
		programNotes: payload.programNotes,
		programID: payload.programID
	})
)

export const editProgramBuildName = createAsyncThunk(
	'editProgramBuild',
	async (payload) => envAwarePost('programsMobWeb/',{
        operation: "edit",
        programLength: payload.programLength,
        programName: payload.newName,
		programNotes: payload.programNotes,
		programID: payload.programID
	})
)

export const editProgramBuildNotes = createAsyncThunk(
	'editProgramBuild',
	async (payload) => envAwarePost('programsMobWeb/',{
        operation: "edit",
        programLength: payload.programLength,
        programName: payload.programName,
		programNotes: payload.newNotes,
		programID: payload.programID
	})
)

export const addEventToProgram = createAsyncThunk(
	'addEventToProgram',
	async (payload) => envAwarePost('programsMobWeb/',{
        operation: "addEvent",
		days: payload.eventDays,
		programID: payload.programID,
		eventType: payload.eventType,
		eventID: payload.eventID
	})
)

export const addMessageToProgram = createAsyncThunk(
	'addMessageToProgram',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "addMessagesToProgram",
		days: payload.eventDays,
		program_id: payload.programID,
		send_at: payload.sendAt,
		is_24_hour_time: payload.is24Hour,
		message_body: payload.messageBody
	})
)

export const updateProgramMessage = createAsyncThunk(
	'updateProgramMessage',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "updateProgramMessage",
		...payload
	})
)

export const deleteProgramMessage = createAsyncThunk(
	'deleteProgramMessage',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "deleteProgramMessage",
		...payload
	})
)

export const deleteProgramMessageGroup = createAsyncThunk(
	'deleteProgramMessageGroup',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "deleteProgramMessageGroup",
		...payload
	})
)

export const editProgramEvent = createAsyncThunk(
	'editProgramEvent',
	async (payload) => envAwarePost('programsMobWeb/',{
        operation: "editEvent",
		day: payload.day,
		programID: payload.programID,
		eventType: payload.eventType,
		eventID: payload.eventID,
		programEventsID: payload.programEventsID
	})
)

export const getAllProgramEvents = createAsyncThunk(
	'getAllProgramEvents',
	async (payload) => envAwarePost('api/programs/api/',{
        action: "getAllProgramEvents",
		program_id: payload.programID,
	})
)

export const getFavoriteDetails = createAsyncThunk(
	'getFavoriteDetails',
	async (payload) => envAwarePost('eventDetailsMobWeb/',{
		client_id: payload.clientID ? payload.clientID : "favorite",
		display: payload.eventID,
		eventType: payload.eventType,
		showEventDetails: "1"
	})
)

export const getEventsForBuildingProgram = createAsyncThunk(
	'getEventsForBuildingProgram',
	async (payload) => envAwarePost(
		'api/programs/api/',
		{action:'getEventsForBuildingProgram'}
	)
)

export const getMessageTemplates = createAsyncThunk(
	'getMessageTemplates',
	async (payload) => envAwarePost('api/programs/api/',{
		action: 'getMessageTemplates',
		limit: 5,
		offset: 0
	})
)

export const assignProgramToClients = createAsyncThunk(
	'assignProgramToClients',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "assignProgram",
		start_date: payload.startDate,
		client_ids: payload.clientList,
		program_id: payload.programID	
	})
)

export const assignProgram = createAsyncThunk(
	'assignProgram',
	async (payload) => envAwarePost('api/programs/api/',{
		action:"assignProgram",
		...payload
	})
)

export const getAllPrograms = createAsyncThunk(
	'getAllPrograms',
	async (payload) => envAwarePost('api/programs/api/',{
		action: "getPrograms",	
	})
)

export const deleteEvent = createAsyncThunk(
	'deleteEvent',
	async payload => envAwarePost('api/programs/',{
		action: "removeProgramEvent",
		day: payload.day,
		program_id: payload.programID,
		event_type: payload.eventType,
		event_id: payload.eventID,
		programEventsID: payload.programEventsID
	})
)

export const deleteAllEvents = createAsyncThunk(
	'deleteAllEvents',
	async payload => envAwarePost('api/programs/',{
		action: "removeProgramEvent",
		delete_all: 1,
		program_id: payload.programID,
		event_type: payload.eventType,
		event_id: payload.eventID
	})
)

const programsAdapter = createEntityAdapter()
const eventsAdapter = createEntityAdapter()

const programAddEditSlice = createSlice({
	name: 'programAddEdit',
	initialState:{
		status: 'init', 
		programs:programsAdapter.getInitialState(), 
		favoriteEvents: [], 
		workouts:[],
		tasks:[],
		nutrition:[],
		programEventsData: {}, 
		programData: {}, 
		messageTemplates: [], 
		allPrograms: [],
		eventSnapshot : {},
	},
    reducers: {
    	clearProgramEventsData:(state)=>{
    		state.programEventsData = {
    			workouts:[],
    			tasks:[],
    			nutritions:[],
    			messages:[]
    		}
    	},
		saveEventSnapshot:(state, action)=>{
			state.eventSnapshot = {
				...action.payload
			}
    	},
		updateEventSnapshot : (state, action) => {
			let payload = action.payload;
			state.eventSnapshot = {
				...state.eventSnapshot, ...payload
			}	
		}
    },
    extraReducers:{
    	[getEventsForBuildingProgram.fulfilled] : (state,action)=>{
    		const {success,message,data} = action.payload
    		if(success === '1'){
    			state.workouts = data.events_by_type.workout
    			state.tasks = data.events_by_type.task
    			state.nutrition = data.events_by_type.nutrition
    		}else{
    			alert(message)
    		}
    	},
        [startProgramBuild.fulfilled] : (state, action) => {
			state.status = 'built'
		
		},
		[addEventToProgram.fulfilled] : (state, action) => {
			
			state.status = 'added'
			
		},
		[addMessageToProgram.fulfilled] : (state, action) => {
			state.status = "added"
		},

		[getAllProgramEvents.fulfilled] : (state,action)=>{
			state.status = 'loaded'
			const {success, data} = action.payload
	
			state.programEventsData = data
			
		},

		[getAllPrograms.fulfilled] : (state,action)=>{
			state.status = 'loaded'
			const {success, data} = action.payload
	
			state.allPrograms = data
			
		},

		[getMessageTemplates.fulfilled] : (state,action)=>{
			state.status = 'loaded'
			const {success, data} = action.payload
			
				//console.log(data)
				
				state.messageTemplates = data
			
		},

		[getFavoriteDetails.fulfilled] : (state,action)=>{
			state.status = 'loaded'
			const {success, data} = action.payload
			
				//console.log(data)
				// programsAdapter.upsertMany(state.programs.events, data)
				state.favoriteEvents = data
			
		},

		[assignProgramToClients.fulfilled] : (state, action) => {
			state.status = 'assigned'
		},

		[editProgramEvent.pending] : (state, action) => {
			state.status = 'editing'
			
		},
		[editProgramBuildLength.pending] : (state, action) => {
			state.status = 'editing'
		},
		[editProgramBuildName.pending] : (state, action) => {
			state.status = 'editing'
		},
		[editProgramBuildNotes.pending] : (state, action) => {
			state.status = 'editing'
		},
		[deleteEvent.fulfilled] : (state, action) => {
			state.status = 'deleted'
			const {success,data} = action.payload
			state.programEventsData  = data;
		},
		[deleteAllEvents.fulfilled] : (state, action) => {
			state.status = 'deleted'
			const {success,data} = action.payload
			state.programEventsData  = data;
		},
    }
})

export const {clearProgramEventsData, saveEventSnapshot, updateEventSnapshot} = programAddEditSlice.actions

export default programAddEditSlice.reducer